import * as React from 'react'
import {
  DeliveryIssueTypes,
  DeliveryIssueStep,
  DeliveryIssueData,
} from '../../../../models/types'
import DeliveryIssueLateCard from './DeliveryIssueLateCard'
import DeliveryIssueNeverDelivered from './DeliveryIssueNeverDelivered'
import { DateStoreHeadingType } from '../components/DateStoreHeading'

type DeliveryIssueCardProps = {
  storeHeading: DateStoreHeadingType
  issueType: DeliveryIssueTypes
  steps: DeliveryIssueStep[]
  issueData: DeliveryIssueData
}

const DeliveryIssueCard: React.FC<DeliveryIssueCardProps> = props => {
  if (props.issueType === DeliveryIssueTypes.NeverDelivered) {
    return <DeliveryIssueNeverDelivered {...props} />
  }

  if (props.issueType === DeliveryIssueTypes.ExtremelyLate) {
    return <DeliveryIssueLateCard {...props} />
  }

  return null
}

export default DeliveryIssueCard
